import api from './api.js'

// 查询企业用户列表
export function getUserPersonalListPage(params){
    return api.get('/service-center/api/v1/user/member/query',params);
}

//重置密码
export function restPassWord(uuid) {
    return api.post(`/service-center/api/v1/user/member/${uuid}/restPassword`);
}

//停用
export function moveUser(uuid,param) {
    return api.post(`/service-center/api/v1/user/member/${uuid}/move`,param);
}

//删除
export function deleteUser(uuid) {
    return api.del(`/service-center/api/v1/user/member/${uuid}`);
}

export function findEnterpriseInfo(uuid) {
    return api.get(`/service-center/api/v1/organization/enterprise/${uuid}`);
}

// 查询企业成员用户列表
export function getUserStaffListPage(params){
    return api.get('/service-center/api/v1/user/staff/managePaginationList',params);
}



// WEBPACK FOOTER //
// ./src/utils/userManager.js